import React from "react";
import Connection from "./Controllers/Connection";

class   RoutingFriend {

    constructor() {
        this.routes=[
           {
                key: "connection",
                parentKey: "dashboard",
                breadcrumb: "دوستان",
                path: "/membership/connection",
                main: () =><Connection />,
                exact: true
            },

        ];

    }

    get(){
        return this.routes;
    }
}

export default RoutingFriend ;
